import { appConfig } from 'config/environment/appConfig'

import { HttpService } from 'services/HttpService'
import { getQueryUrl } from 'services/utils/getQueryUrl'
import { TokensDTO } from 'sections/LKSection/shared/types/types'
import convertKeysToCamelCase from 'utils/helpers/convertKeysToCamelCase'
import { PaginationType, ResponseListData } from 'shared/types/types'

import { TimetableStatus } from './types/types'
import { PvzDTO, SignboardDTO, UpdatePvzRequest, UpdateSignboardData } from './types/typesDTO'

const discoveryService = new HttpService(appConfig.DISCOVERY_URL)

export const pvzApi = {
  getPvzList: async ({ page, pageSize }: PaginationType): Promise<ResponseListData<PvzDTO[]>> => {
    const queryUrl = getQueryUrl({
      page_size: pageSize,
      page,
    })

    const result = await discoveryService.get<ResponseListData<PvzDTO[]>>(`/api/v2/pickpoint/list?${queryUrl}`)

    return result ? convertKeysToCamelCase(result) : undefined
  },

  updatePvz: (data: UpdatePvzRequest, updatedFields?: string[]): Promise<{ data: number }> => {
    const patch = {
      description: data.description,
      courier_way: data.courierWay,
      alarm_system: data.alarmSystem,
      metadata: data.courierWay,
      dressing_rooms_count: data.dressingRoomsCount,
      actual_urls: data.actualUrls,
      requested_area: data.area,
      stock_area: data.warehouseArea,
      timetable: data.timetable,
      timetable_update_reason: data.timetableUpdateReason,
      racks_count: data.racksCount,
      cells_count: data.cellsCount,
      max_cells_count: data.maxCellsCount,
      features: data.features,
    }

    const updatedFieldsLocal =
      updatedFields ??
      Object.entries(patch)
        .filter(([, value]) => value !== undefined && value !== null)
        .map(([key]) => key)

    return discoveryService.post(`/api/v2/pickpoint/${data.pvzId}/update`, {
      body: {
        ...patch,
        update_fields: updatedFieldsLocal,
      },
    })
  },

  switchPvz: async (pvzId: number): Promise<TokensDTO> => {
    const result = await discoveryService.get(`/api/v2/pickpoint/${pvzId}/switch`)
    return result ? convertKeysToCamelCase(result) : undefined
  },

  getTimetableEditStatus: async (pvzId: number): Promise<{ status: TimetableStatus } | null> => {
    const result = await discoveryService.get<{ timetable_order: { status: TimetableStatus } | null }>(
      `/api/v4/pickpoint/${pvzId}/timetable-order`,
    )

    return result?.timetable_order
  },

  getPvzSignboard: async (pickpointId: number): Promise<SignboardDTO> => {
    const result = await discoveryService.get<SignboardDTO>(`/api/v2/pickpoint/signboard/${pickpointId}`, {})

    return convertKeysToCamelCase(result)
  },

  updatePvzSignboard: async (patch: UpdateSignboardData) => {
    const result = await discoveryService.post('/api/v2/pickpoint/signboard/update', { body: patch })
    return result
  },
}
